import { Avatar, CircularProgress, FormHelperText } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { find } from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import { FormControl } from './index';
import { Typography } from '@mui/material';
import moment from 'moment';
import { DateTimeContext } from 'src/contexts/DateTimeContext';
import { RenderMonth } from '@utils/constant';

const renderPayRollContent = (option) => {
  return(
  <>
    <Typography sx={{ marginLeft: '10px' }}>
      <Typography component="span" fontWeight={700}>
        Pay Seq
      </Typography>
      :{' '}
      <Typography component="span" mr={2}>
        {option?.pay_seq || 'N/A'}
      </Typography>
      <Typography component="span" fontWeight={700}>
        Month
      </Typography>
      :{' '}
      <Typography component="span" mr={2}>
        {RenderMonth(option?.month) || 'N/A'}
      </Typography>
      <Typography component="span" fontWeight={700}>
        Pay Date
      </Typography>
      :{' '}
      <Typography component="span" mr={2}>
        {option?.pay_date || 'N/A'}
      </Typography>
    </Typography>
  </>)
}

const renderJobDropDownContent = (option) => (
  <>
    <Typography sx={{ marginLeft: '10px' }}>
      <Typography component="span" fontWeight={700}>
        Name
      </Typography>
      :{' '}
      <Typography component="span" mr={2}>
        {option?.name || 'N/A'}
      </Typography>
      <Typography component="span" fontWeight={700}>
        Job Type
      </Typography>
      :{' '}
      <Typography component="span" mr={2}>
        {option?.job_type_name || 'N/A'}
      </Typography>
      <Typography component="span" fontWeight={700}>
        Description
      </Typography>
      :{' '}
      <Typography component="span" mr={2}>
        {option?.description || 'N/A'}
      </Typography>
    </Typography>
  </>
);

const renderJobContent = (option) => (
  <>
    <Typography sx={{ marginLeft: '10px' }}>
      <Typography component="span" fontWeight={700}>
        Name
      </Typography>
      :{' '}
      <Typography component="span" mr={2}>
        {option?.name || 'N/A'}
      </Typography>
      {option?.job_type && (
        <>
          <Typography component="span" fontWeight={700}>
            Job Type
          </Typography>
          :{' '}
          <Typography component="span" mr={2}>
            {option?.job_type || 'N/A'}
          </Typography>
        </>
      )}
      {option?.description && (
        <>
          <Typography component="span" fontWeight={700}>
            Description
          </Typography>
          :{' '}
          <Typography component="span" mr={2}>
            {option?.description || 'N/A'}
          </Typography>
        </>
      )}
    </Typography>
  </>
);

const renderJobPhaseContent = (option) => (
  <>
    <Typography sx={{ marginLeft: '10px' }}>
      <Typography component="span" fontWeight={700}>
        Name
      </Typography>
      :{' '}
      <Typography component="span" mr={2}>
        {option?.name || 'N/A'}
      </Typography>
      {option?.code && (
        <>
          <Typography component="span" fontWeight={700}>
            Code
          </Typography>
          :{' '}
          <Typography component="span" mr={2}>
            {option?.code || 'N/A'}
          </Typography>
        </>
      )}
      {option?.description && (
        <>
          <Typography component="span" fontWeight={700}>
            Description
          </Typography>
          :{' '}
          <Typography component="span" mr={2}>
            {option?.description || 'N/A'}
          </Typography>
        </>
      )}
      {option?.associated_job_name && (
        <>
          <Typography component="span" fontWeight={700}>
            Associated Job Name
          </Typography>
          :{' '}
          <Typography component="span" mr={2}>
            {option?.associated_job_name || 'N/A'}
          </Typography>
        </>
      )}
    </Typography>
  </>
);

const renderPayPeriodContent = (option) => {
  return (
    <>
      <Typography sx={{ marginLeft: '10px' }}>
        <Typography component="span" fontWeight={700}>
          Name
        </Typography>
        :{' '}
        <Typography component="span" mr={2}>
          {option?.name || 'N/A'}
        </Typography>
        <Typography component="span" fontWeight={700}>
          Month
        </Typography>
        :{' '}
        <Typography component="span" mr={2}>
          {option?.month ? moment(option?.month).format('MMM') : 'N/A'}
        </Typography>
        <Typography component="span" fontWeight={700}>
          End Date
        </Typography>
        :{' '}
        <Typography component="span" mr={2}>
          {option?.endDate || 'N/A'}
        </Typography>
        <Typography component="span" fontWeight={700}>
          PR Group
        </Typography>
        :{' '}
        <Typography component="span" mr={2}>
          {option?.pay_group || 'N/A'}
        </Typography>
        <Typography component="span" fontWeight={700}>
          Description
        </Typography>
        :{' '}
        <Typography component="span" mr={2}>
          {option?.description || 'N/A'}
        </Typography>
      </Typography>
    </>
  );
};

const renderCrewContent = (option) => (
  <>
    <Typography sx={{ marginLeft: '10px' }}>
      <Typography component="span" fontWeight={700}>
        Name
      </Typography>
      :{' '}
      <Typography component="span" mr={2}>
        {option?.name || 'N/A'}
      </Typography>
      {option?.code && (
        <>
          <Typography component="span" fontWeight={700}>
            Code
          </Typography>
          :{' '}
          <Typography component="span" mr={2}>
            {option?.code || 'N/A'}
          </Typography>
        </>
      )}
      {option?.detail && (
        <>
          <Typography component="span" fontWeight={700}>
            Description
          </Typography>
          :{' '}
          <Typography component="span" mr={2}>
            {option?.detail || 'N/A'}
          </Typography>
        </>
      )}
    </Typography>
  </>
);
const SelectAutoComplete = (props) => {
  const {
    variant,
    inputValue,
    onBlur,
    selectOption,
    onInputChange,
    getOptionLabel,
    getOptionValue,
    onChange,
    name,
    label,
    value,
    required,
    fullWidth,
    helperText,
    disabled,
    options,
    loading,
    starReq,
    isImage,
    isString,
    isDescription,
    disableClearable,
    description = false,
    isPayPeriods,
    isJobSelect,
    isJobDropDownSelect,
    isJobPhaseSelect,
    isCrewDropdownSelect,
    styled,
    type,
    size,
    isPayRoll
  } = props;
  const [optionsData, setOptionData] = React.useState([]);
  const [option, setOption] = React.useState([]);
  const { dateFormatConvertByMoment } = React.useContext(DateTimeContext);
  const getLabel = React.useCallback(
    (element) => {
      if (element && element[getOptionLabel]) {
        return element[getOptionLabel];
      } else {
        return '';
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [getOptionLabel]
  );

  const getValue = React.useCallback((element) => {
    if (element && element[getOptionValue]) {
      return element[getOptionValue];
    } else {
      return '';
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  React.useEffect(() => {
    let optionsData = [];
    if (options) {
      options.map((element) => {
        if (getLabel(element)) {
          optionsData.push({
            label: getLabel(element),
            value: getValue(element),
            ...(isImage && { image: element?.resource_image }),
            ...(isDescription && { description: description ? element[description] : element?.description || '' }),
            // Payroll Content Load
            ...(isPayRoll && {
              pay_seq: element?.name,
              month: element?.month,
              pay_date: element?.pay_date,
            }),
            // PayPeriod ContentLoad
            ...(isPayPeriods && {
              startDate: element?.start_date,
              endDate: dateFormatConvertByMoment(element?.end_date),
              name: element?.pay_period,
              month: element?.month,
              pay_group: element?.pay_group,
              description: element?.description,
            }),
            // JobSelect Content Load
            ...(isJobSelect && {
              name: element?.name,
              job_type: element?.job_type?.name || element?.job_type,
              description: element?.description,
            }),
            // JobSelect dropdown Content Load
            ...(isJobDropDownSelect && {
              name: element?.name,
              job_type_name: element?.job_type_name || 'N/A',
              description: element?.description || 'N/A',
            }),
            // JobPhase contentLoad
            ...(isJobPhaseSelect && {
              name: element?.name,
              code: element?.code,
              associated_job_name: element?.job?.name,
              description: element?.description,
            }),
            // Crew content Load
            ...(isCrewDropdownSelect && {
              name: element?.name,
              code: element?.code,
              detail: element?.detail,
            })
          });
        }
      });
    }
    setOptionData(optionsData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options]);

  React.useEffect(() => {
    const defaultValue = find(optionsData, { value: isString ? value : Number(value) });
    if (defaultValue) {
      setOption(defaultValue);
    } else if (selectOption) {
      const defaultOption = {
        label: getLabel(selectOption),
        value: getValue(selectOption),
      };
      setOption(defaultOption);
    } else {
      setOption(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, selectOption, optionsData]);

  const renderContentCondi = (option) => {
    if (isPayPeriods) {
      return renderPayPeriodContent(option);
    } else if (isJobSelect) {
      return renderJobContent(option);
    } else if (isJobDropDownSelect) {
      return renderJobDropDownContent(option);
    } else if (isJobPhaseSelect) {
      return renderJobPhaseContent(option);
    } else if (isCrewDropdownSelect) {
      return renderCrewContent(option);
    } else if(isPayRoll) {
      return renderPayRollContent(option);
    } else {
      return option.label;
    }
  };

  return (
    <FormControl
      size={size}
      style={styled}
      key={`key${name}`}
      error={helperText ? true : false}
      fullWidth={fullWidth}
      required={required}
    >
      <Autocomplete
        size={size}
        disabled={disabled}
        options={optionsData}
        onBlur={onBlur}
        value={option}
        disableClearable={disableClearable}
        inputValue={inputValue}
        variant={variant}
        onInputChange={(event, newValue) => {
          if (event?.type === 'change') {
            onInputChange(newValue || '');
          } else {
            onInputChange(null);
          }
        }}
        getOptionLabel={(option) => option.label || ''} //MUI warning issue fixed by this code in autoComplete
        autoHighlight
        loading={loading}
        onChange={(event, newValue) => {
          if (event?.type === 'click') {
            if (type === 'unitOfMeasurment') {
              onChange(newValue || '');
            } else {
              onChange(newValue?.value || '');
            }
          } else {
            onChange(null);
          }
        }}
        renderOption={(props, option) => (
          <Box
            key={`${name}-option-${option.value}`}
            component="li"
            sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
            {...props}
          >
            {isImage && <Avatar sx={{ marginRight: '10px' }} src={option?.image} />}
            {renderContentCondi(option)}
            {isDescription && (
              <Typography sx={{ marginLeft: '10px' }}>{option?.description && `(${option?.description})`}</Typography>
            )}
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            error={helperText ? true : false}
            {...params}
            label={label}
            variant={variant}
            required={starReq}
            InputProps={{
              ...params.InputProps,
              style: styled,
              autoComplete: 'off', // disable autocomplete and autofill
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

SelectAutoComplete.defaultProps = {
  fullWidth: true,
  required: false,
  disabled: false,
  loading: false,
  variant: 'outlined',
  options: [],
  value: null,
  label: 'name',
  onChange: () => { },
  onInputChange: () => { },
  onBlur: () => { },
  selectOption: {},
};

SelectAutoComplete.propTypes = {
  onChange: PropTypes.func,
  onInputChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  options: PropTypes.array,
  loading: PropTypes.bool,
  inputValue: PropTypes.string,
  getOptionLabel: PropTypes.string,
  getOptionValue: PropTypes.string,
  variant: PropTypes.string,
  selectOption: PropTypes.object,
  starReq: PropTypes.bool,
  isString: PropTypes.any,
  isImage: PropTypes.any,
  isDescription: PropTypes.any,
  disableClearable: PropTypes.any,
  description: PropTypes.any,
  isPayPeriods: PropTypes.any,
  isJobSelect: PropTypes.any,
  isJobDropDownSelect: PropTypes.any,
  isJobPhaseSelect: PropTypes.any,
  isCrewDropdownSelect: PropTypes.any,
  styled: PropTypes.any,
  type: PropTypes.any,
};

export default SelectAutoComplete;
